module.exports = __webpack_public_path__ + "static/media/productos_otros_pepita_amarilla.2d00d3ab.jpg";